/* Venta cruzada en el carrito lateral: añade la sugerencia y vuelve a pintar el carrito. */
(function () {
  if (window.pcCrossSell) return;
  window.pcCrossSell = true;

  document.addEventListener('click', function (event) {
    var btn = event.target.closest('[data-pc-cs-add]');
    if (!btn) return;
    event.preventDefault();
    if (btn.disabled) return;
    btn.disabled = true;
    btn.classList.add('is-loading');

    var drawer = document.querySelector('cart-drawer');
    fetch((window.routes && window.routes.cart_add_url ? window.routes.cart_add_url : '/cart/add') + '.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({
        items: [{ id: Number(btn.dataset.pcCsAdd), quantity: 1 }],
        sections: ['cart-drawer', 'cart-icon-bubble'],
        sections_url: window.location.pathname,
      }),
    })
      .then(function (r) { return r.json(); })
      .then(function (state) {
        if (state.status) throw new Error(state.description || state.message);
        if (drawer && typeof drawer.renderContents === 'function' && state.sections) {
          drawer.renderContents(state);
        } else {
          window.location.href = window.routes && window.routes.cart_url ? window.routes.cart_url : '/cart';
        }
      })
      .catch(function () {
        btn.disabled = false;
        btn.classList.remove('is-loading');
      });
  });
})();

/* Paw & Co · el icono del carrito da un saltito y el número entra de nuevo cuando añades algo (2026-10-18).
   Dawn sustituye el contenido de #cart-icon-bubble tras añadir; comparamos el número y animamos solo si sube. */
(function () {
  var icono = document.getElementById('cart-icon-bubble');
  if (!icono || !('MutationObserver' in window)) return;
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
  function cuenta() { var b = icono.querySelector('.cart-count-bubble span[aria-hidden]'); return b ? parseInt(b.textContent, 10) || 0 : 0; }
  var antes = cuenta();
  new MutationObserver(function () {
    var ahora = cuenta();
    if (ahora > antes) {
      icono.classList.remove('pc-salta');
      void icono.offsetWidth; // reinicia la animación si se añade dos veces seguidas
      icono.classList.add('pc-salta');
    }
    antes = ahora;
  }).observe(icono, { childList: true, subtree: true, characterData: true });
  icono.addEventListener('animationend', function (e) { if (e.target === icono.querySelector('.svg-wrapper')) icono.classList.remove('pc-salta'); });
})();

/* Paw & Co · foto de producto con fundido al cambiar de color o pulsar una miniatura (2026-10-18).
   Dawn marca con .is-active la foto activa (media-gallery.setActiveMedia); al cambiar, la nueva entra
   con fundido + un leve desenfoque que se aclara (enmascara el salto). Solo transform/opacity/filter. */
(function () {
  if (!('MutationObserver' in window) || !Element.prototype.animate) return;
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
  function preparar(galeria) {
    var visor = galeria.querySelector('[id^="GalleryViewer"]') || galeria.querySelector('slider-component') || galeria;
    if (!visor || visor.dataset.pcFundido) return;
    visor.dataset.pcFundido = '1';
    var activa = visor.querySelector('li[data-media-id].is-active');
    new MutationObserver(function () {
      var nueva = visor.querySelector('li[data-media-id].is-active');
      if (!nueva || nueva === activa) return;
      activa = nueva;
      var foto = nueva.querySelector('.product__media img, img');
      if (!foto) return;
      foto.animate(
        [{ opacity: 0.25, transform: 'scale(1.035)', filter: 'blur(6px)' }, { opacity: 1, transform: 'scale(1)', filter: 'blur(0)' }],
        { duration: 420, easing: 'cubic-bezier(0.23, 1, 0.32, 1)' }
      );
    }).observe(visor, { subtree: true, attributes: true, attributeFilter: ['class'], childList: true });
  }
  function iniciar() { document.querySelectorAll('media-gallery').forEach(preparar); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', iniciar); else iniciar();
  document.addEventListener('shopify:section:load', iniciar);
})();

/* Paw & Co · página de producto (2026-10-18): ✓ en el botón al añadir, salto del número de cantidad
   y fundido del precio al cambiar de variante. */
(function () {
  var quieto = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  // ✓ en «Agregar al carrito»: cuando el contador del carrito sube tras enviar un formulario de producto
  var ultimoBoton = null;
  document.addEventListener('submit', function (e) {
    var b = e.target && e.target.querySelector && e.target.querySelector('.product-form__submit');
    if (b) ultimoBoton = b;
  }, true);
  var icono = document.getElementById('cart-icon-bubble');
  if (icono && 'MutationObserver' in window) {
    var n = function () { var s = icono.querySelector('.cart-count-bubble span[aria-hidden]'); return s ? parseInt(s.textContent, 10) || 0 : 0; };
    var antes = n();
    new MutationObserver(function () {
      var ahora = n();
      if (ahora > antes && ultimoBoton) {
        var b = ultimoBoton; ultimoBoton = null;
        b.classList.add('pc-ok');
        setTimeout(function () { b.classList.remove('pc-ok'); }, 1400);
      }
      antes = ahora;
    }).observe(icono, { childList: true, subtree: true, characterData: true });
  }
  if (quieto) return;
  // Cantidad: el número salta hacia arriba al sumar y hacia abajo al restar
  document.addEventListener('click', function (e) {
    var btn = e.target.closest && e.target.closest('.quantity__button');
    if (!btn) return;
    var input = btn.parentElement && btn.parentElement.querySelector('.quantity__input');
    if (!input) return;
    input.style.setProperty('--pc-dir', btn.name === 'minus' ? '4px' : '-4px');
    input.classList.remove('pc-cambia'); void input.offsetWidth; input.classList.add('pc-cambia');
  });
  // Precio: fundido corto cuando Dawn lo sustituye al cambiar de variante
  if (!('MutationObserver' in window) || !Element.prototype.animate) return;
  document.querySelectorAll('product-info [id^="price-"]').forEach(function (caja) {
    new MutationObserver(function () {
      var p = caja.querySelector('.price');
      if (p) p.animate([{ opacity: 0, transform: 'translateY(4px)' }, { opacity: 1, transform: 'none' }], { duration: 260, easing: 'cubic-bezier(0.23, 1, 0.32, 1)' });
    }).observe(caja, { childList: true });
  });
})();
